import { useContext, useState } from "react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { iconButtonStyles } from "../../../../components/Modal/ModalHeader";
import ResetIcon from "../../../../components/SVGComponents/ResetIcon";
import { t } from "i18next";
import ConfirmModal from "../../../../components/Modal/ConfirmModal";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";

const ResetReport = () => {
  const [showResetReport, setShowResetReport] = useState(false);
  const { disableResetReport, isAgenticTab, handleResetReportForActiveTab} = useContext(
    AgenticReportingContext,
  );

  const { activeTab } = useContext(studyReportContext);

  const handleConfirmReset = () => {
    handleResetReportForActiveTab();
    setShowResetReport(false);
  };

  const handleReportResetSuccessCloseModal = () => {
    if (showResetReport) {
      setShowResetReport(false);
    }
  };

  return (
    <CustomToolTipHost
      content={"Reset report"}
      id="Reset report"
      tooltipProps={{
        calloutProps: {
          styles: {
            beak: { background: "#252525;" },
            beakCurtain: { background: "#252525;" },
            calloutMain: { background: "#252525;" },
            borderRadius: "20%",
          },
        },
      }}
    >
      <div
        className="highlight-tool-llm"
        styles={iconButtonStyles}
        style={{
          cursor: `${!disableResetReport && isAgenticTab && activeTab !== 2 ? "pointer" : "not-allowed"}`,
          marginTop: "2px",
        }}
        onClick={() => {
          if (!disableResetReport && isAgenticTab && activeTab !== 2 ) setShowResetReport(true);
        }}
      >
        <ResetIcon resetAllowed={!disableResetReport && isAgenticTab} />
      </div>
      {showResetReport && (
        <ConfirmModal
          handleConfirm={handleConfirmReset}
          handleNotConfirm={handleReportResetSuccessCloseModal}
          setShowConfirmModal={setShowResetReport}
          showConfirmModal={showResetReport}
          message={t("confirm-message.reset-report-confirmation")}
          title={t("confirm-message.confirm-reset-report")}
          confirmButtonText={t("confirm-message.yes")}
          cancelButtonText={"Cancel"}
        />
      )}
    </CustomToolTipHost>
  );
};

export default ResetReport;
